import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from "vuetify/lib/iconsets/mdi";
import '@mdi/font/css/materialdesignicons.css';
import { CustomTheme } from './theme'
import { fa } from "vuetify/iconsets/fa";
// make sure to also import the coresponding css
import '@fortawesome/fontawesome-free/css/all.css' // Ensure your project is capable of handling css files
import { md } from 'vuetify/iconsets/md'
import 'material-icons/iconfont/material-icons.css'  // Add this for Material Icons

const vuetify = createVuetify({
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
      fa,
      md
    },
  },
  theme: {
    defaultTheme: 'CustomTheme',
    themes: {
      CustomTheme,
    },
  },
  defaults: {
    global: {
      font: {
        family: 'Poppins, sans-serif',
      },
    },
    VBtn: {
      rounded: 'lg',
      variant: 'flat',
      elevation: 0,
      class: 'text-none',
    },
    VCard: {
      rounded: 'lg',
      elevation: 0,
      class: 'border-thin',
    },
    VTextField: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VTextarea: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VSelect: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VAutocomplete: {
      variant: 'outlined',
      rounded: 'lg',
      density: 'default',
    },
    VSwitch: {
      color: 'accent-color',
      inset: true,
      density: 'compact',
    },
    VAlert: {
      density: 'compact',
      rounded: 'lg',
    },
    VAlert: {
      rounded: 'lg',
    },
    VSnackbar: {
      rounded: 'lg',
      density: 'compact',
    },
  },
})

export default vuetify;
